import { useEffect, useRef } from 'react';

type KeyboardEventCallback = (event: KeyboardEvent) => void;

const useKeyboardListener = (
  keydownCallback: KeyboardEventCallback,
  keyupCallback?: KeyboardEventCallback,
): void => {
  const keydownCallbackRef = useRef<KeyboardEventCallback>(keydownCallback);
  const keyupCallbackRef = useRef<KeyboardEventCallback>(keyupCallback);

  useEffect(() => {
    keydownCallbackRef.current = keydownCallback;
  }, [keydownCallback]);

  useEffect(() => {
    keyupCallbackRef.current = keyupCallback;
  }, [keyupCallback]);

  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent): void => {
      keydownCallbackRef.current(event);
    };

    document.addEventListener('keydown', handleKeydown);

    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  useEffect(() => {
    if (!keyupCallbackRef?.current) {
      return;
    }

    const handleKeyUp = (event: KeyboardEvent): void => {
      keyupCallbackRef.current!(event);
    };

    document.addEventListener('keyup', handleKeyUp);

    return () => {
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);
};

export default useKeyboardListener;
